export const getSelectActivityOpen = (state) => {
  return state?.selectActivity?.open;
};

export const getSelectActivityOptions = (state) => {
  return state?.selectActivity?.options;
};
